var MenuComponent = /** @class */ (function () {
    function MenuComponent() {
        //this.myCalendarUrl = process.env.HOST_URL + 'meeting/calendar-profile/home' + (localStorage.authorization.split(' ')[1])
        this.myCalendarUrl = process.env.HOST_URL + 'meeting/calendar-profile/home';
    }
    return MenuComponent;
}());
export { MenuComponent };
//# sourceMappingURL=commons.component.js.map